export const LOGIN_FAILED =
  "No active account found with the given credentials";
export const LOGIN_SUCCESSFUL = "Login Successful";
export const FORGOTPASSWORD_FAILED =
  "No active account found with the given credentials";
export const RESETPASSWORD_FAILED =
  "Something went wrong, please try again later";
export const SUBMIT_SUCCESSFUL = "Submit Successful";
export const RESET_PASSWORD_SUCCESSFUL = "Reset Password Successful";
export const SERVER_ERROR = "Please try again later";
export const HOME_REDIRECT = "Redirecting you to home page...";

export const BRANCH = "branch";
export const SUPERADMIN = "superadmin";
export const MASTERADMIN = "masteradmin";
export const PRINCIPAL = "principal";
export const MANAGER = "manager";
export const TEACHER = "teacher";
export const PARENT = "parent";

export const MIN_ROWS_TO_DISPLAY_TOP_PAGINATION = 10;